<template lang="pug">
.text-input
  input.form-input(
    :type="inputType"
    :id="inputId"
    :name="name"
    :disabled="disabled"
    :required="required"
    :placeholder="placeholder"
    v-model="currentValue"
    @focusout="validate"
  )
  .form-input__error-message(
    v-if="valueIsErroneous"
  ) {{ errorText }}
</template>

<script>
  export default {
    name: 'TextInput',
    props: {
      id: String,
      name: String,
      disabled: Boolean,
      required: Boolean,
      label: String,
      placeholder: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: 'text',
      },
      error: {
        type: Boolean,
        default: false,
      },
      errorText: {
        type: String,
        default: 'This field must be filled in.',
      },
      emailCapture: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        currentValue: this.value,
        valueIsErroneous: this.error,
      };
    },
    computed: {
      classes() {
        return {
          'text-input--error': this.valueIsErroneous,
          'text-input--disabled': this.disabled,
          'text-input--email-capture': this.emailCapture,
        };
      },
      inputId() {
        return this.id || `input_${this._uid}`;
      },
      inputType() {
        return this.isTextArea ? null : this.type;
      },
    },
    watch: {
      currentValue() {
        this.validate();
        this.$emit('input', this.currentValue);
      },
    },
    methods: {
      set(val) {
        this.currentValue = val;
      },
      validate() {
        let isValid = true;

        if (this.required) {
          isValid = !!this.currentValue;
        }

        if (this.currentValue && this.type === 'email') {
          const emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
          isValid = this.currentValue.match(emailPattern) !== null;
        }

        if (this.currentValue && this.pattern) {
          let validationPattern = this.pattern;

          if (validationPattern[0] === '/') validationPattern = validationPattern.slice(1);
          if (validationPattern[validationPattern.length - 1] === '/') validationPattern = validationPattern.slice(0, -1);

          validationPattern = new RegExp(validationPattern);
          isValid = this.currentValue.match(validationPattern) !== null;
        }
        this.valueIsErroneous = !isValid;
      },
    },
  };
</script>
